module.exports = __webpack_public_path__ + "img/internet.df780bd7.svg";